import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase configuration missing');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Database = {
  public: {
    Tables: {
      mapa_grupos: {
        Row: {
          id: string;
          nombre: string;
          color: string;
          created_at: string;
        };
        Insert: {
          id?: string;
          nombre: string;
          color: string;
          created_at?: string;
        };
        Update: {
          id?: string;
          nombre?: string;
          color?: string;
          created_at?: string;
        };
      };
      mapa_actividades: {
        Row: {
          id: string;
          nombre: string;
          latitud: number;
          longitud: number;
          fecha: string;
          grupo_id: string;
          alcance: number;
          created_at: string;
        };
        Insert: {
          id?: string;
          nombre: string;
          latitud: number;
          longitud: number;
          fecha: string;
          grupo_id: string;
          alcance?: number;
          created_at?: string;
        };
        Update: {
          id?: string;
          nombre?: string;
          latitud?: number;
          longitud?: number;
          fecha?: string;
          grupo_id?: string;
          alcance?: number;
          created_at?: string;
        };
      };
    };
  };
};